import type { Vehicle } from '@/types/domain';
import { useCallback } from 'react';
import { useFirestoreCollection, type FirestoreConstraintsBuilder } from './useFirestoreCollection';

export function useUserVehicles(uid: string | null | undefined) {
  const buildConstraints = useCallback<FirestoreConstraintsBuilder>(
    (sdk) =>
      uid ? [sdk.where('current_owner_uid', '==', uid), sdk.orderBy('updatedAt', 'desc')] : [],
    [uid],
  );
  return useFirestoreCollection<Vehicle>(uid ? 'vehicles' : null, buildConstraints);
}
